export default __webpack_public_path__ + "static/media/Car.d0a74187.png";